module.exports = global["Nette"] = require("-!/Users/michal/Sites/copt/node_modules/source-map-loader/index.js!./netteForms.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/nette-forms/src/assets/netteForms.js-exposed
// module id = 36
// module chunks = 0 1 2